import { useState } from "react";
import { useTranslation } from "react-i18next";
const faqs = [
  {
    q: "How long does it take?",
    a: "Onboarding takes a few minutes. The total timeline depends on your documents and canton, but we guide each step.",
  },
  {
    q: "Do you serve all cantons?",
    a: "Yes! We support all 26 Swiss cantons. Our system automatically applies the correct cantonal tax rules and rates for your situation.",
  },
  {
    q: "Is my data secure?",
    a: "Absolutely. All data is encrypted in transit and at rest, stored on Swiss servers. We never share your information with third parties.",
  },
  {
    q: "How do I start?",
    a: "Simply click 'Start Questionnaire', answer a few quick questions about your income, canton, and situation — we handle the rest.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useTranslation();
  return (
    <section id="faqs" className="w-full px-4 py-16 bg-white md:px-10">
      <div className="max-w-[1536px] mx-auto flex flex-col gap-10">
        <div className="text-center animate-on-scroll">
          <h2
            className="block font-bold font-poppins text-dark"
            style={{ fontSize: "clamp(24px, 3.5vw, 36px)" }}>
            {t("frequentlyAsked")}
          </h2>
          <span
            className="
    mb-5 font-black leading-tight font-poppins
    text-2xl md:text-3xl lg:text-4xl
    bg-[linear-gradient(90deg,#22D3EE_0%,#06B6D4_35%,#0EA5E9_65%,#22C55E_100%)]
    bg-clip-text text-transparent
  ">
            {t("Questions")}
          </span>
        </div>

        <div className="flex flex-col w-full max-w-3xl gap-3 mx-auto">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`overflow-hidden transition-all duration-200 rounded-xl animate-on-scroll stagger-${i + 1}`}
                style={{
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                  // border: isOpen ? "1px solid #007AB7" : "1px solid white",
                  borderLeft: isOpen
                    ? "4px solid #007AB7"
                    : "1px solid #E5E7EB",
                }}>
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex items-center justify-between w-full gap-4 px-5 py-4 text-left transition-colors border-none cursor-pointer">
                  <span className="font-poppins font-semibold text-dark text-[14px] sm:text-[15px]">
                    {t(faq.q)}
                  </span>

                  {/* Chevron */}
                  <span className="shrink-0">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      style={{
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                      }}>
                      <path
                        d="M4 6l5 5 5-5"
                        stroke={isOpen ? "#007AB7" : "#94A3B8"}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>

                <div
                  className="overflow-hidden"
                  style={{
                    maxHeight: isOpen ? "200px" : "0px",
                    opacity: isOpen ? 1 : 0,
                    transition: "max-height 0.4s ease-out, opacity 0.3s ease",
                  }}>
                  <p
                    className="p-3 m-5 mt-0 font-sans text-sm leading-relaxed rounded-md text-text"
                    style={{ background: "#EBF5FB" }}>
                    {t(faq.a)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}